import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import Access from "./Components/Access";
import IncidendesFinancieresGlobalOperations from "./Components/IncidendesFinancieresGlobalOperations";
import Navbar from "./Components/Navbar";
import GanttSyntheseOperations from "./Components/GanttSyntheseOperations";
import { addSpace } from "./Components/Tools";
import {NotificationManager} from 'react-notifications';
import { ReactComponent as Trash } from './Img/icon-trash.svg';
import { ReactComponent as Add } from './Img/icon-add.svg';
import { useHistory } from 'react-router-dom';
import Dialog from "./Components/Dialog";

const Operations = (props) =>
{
    const history = useHistory();
    const [aff, setAff] = useState(false);
    const [operations, setOperations] = useState([]);
    const [modalites, setModalites] = useState([]);
    const [axes, setAxes] = useState([]);
    const [territoires, setTerritoires] = useState([]);
    const [clients, setClients] = useState([]);
    const [modaliteFilter, setModaliteFilter] = useState('');
    const [axeFilter, setAxeFilter] = useState('');
    const [territoireFilter, setTerritoireFilter] = useState('');
    const [clientFilter, setClientFilter] = useState('');
    const [searchText, setSearchText] = useState('');
    const [searchNumero, setSearchNumero] = useState('');
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    const [idSelected, setIdSelected] = useState(null);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');
    const [ongletListeOperations, setOngletListeOperations] = useState(true);
    const [ongletSyntheseGantt, setOngletSyntheseGantt] = useState(false);
    const [ongletIncidencesFinancieres, setOngletIncidencesFinancieres] = useState(false);
    const [anneeDebut, setAnneeDebut] = useState('');
    const [anneeFin, setAnneeFin] = useState('');
    const [isRecalculating, setIsRecalculating] = useState(false);

    const purple = '#6571FE';
    const green = '#59B44A';
    

    async function callbackDialog(ret) {
        if (ret === true) {
            await suppressProjet(idSelected);
        }
        await setIdSelected(null);
    }

    async function mount() {
        if (!props.user) return;

        // Initialiser les années de début et fin
        if (props.user.config_budget) {
            if (props.user.config_budget.retro_an_deb) {
                setAnneeDebut(props.user.config_budget.retro_an_deb);
            }
            if (props.user.config_budget.prosp_an_fin) {
                setAnneeFin(props.user.config_budget.prosp_an_fin);
            }
        }

        // liste des opérations de l'id_budget
        try {
            const res = await axios.post('/api/operations.php', qs.stringify({ get: true, id_budget: props.user.id_budget }));
            if (res && res.data) {
                // API returns { status:1, count:, data: [...] } or similar
                let list = Array.isArray(res.data) ? res.data : (res.data.data ? res.data.data : []);
                
                // Filtrer par droits de visualisation si l'utilisateur est de type 3 (simple user)
                if (props.user.id_type_users == 3) {
                    list = list.filter(op => {
                        const droits_visu = (op.id_users_droits_visu || '').split(';').map(id => id.trim()).filter(id => id !== '');
                        return droits_visu.includes(String(props.user.id));
                    });
                }
                
                setOperations(list || []);
            } else setOperations([]);
        } catch (err) {
            console.warn(err);
            setOperations([]);
        }

        // modalites (pour filtre) — on utilise id_organisme comme les autres pages
        try {
            const rm = await axios.post('/api/modalites_portage.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (rm && rm.data) setModalites(Array.isArray(rm.data) ? rm.data : (rm.data.data ? rm.data.data : []));
            else setModalites([]);
        } catch (err) {
            console.warn(err);
            setModalites([]);
        }

        // axes d'interventions
        try {
            const ra = await axios.post('/api/axes_interventions.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (ra && ra.data) setAxes(Array.isArray(ra.data) ? ra.data : (ra.data.data ? ra.data.data : []));
            else setAxes([]);
        } catch (err) {
            console.warn(err);
            setAxes([]);
        }

        // territoires
        try {
            const rt = await axios.post('/api/territoires.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (rt && rt.data) setTerritoires(Array.isArray(rt.data) ? rt.data : (rt.data.data ? rt.data.data : []));
            else setTerritoires([]);
        } catch (err) {
            console.warn(err);
            setTerritoires([]);
        }

        // clients
        try {
            const rc = await axios.post('/api/clients_epfl.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
            if (rc && rc.data) setClients(Array.isArray(rc.data) ? rc.data : (rc.data.data ? rc.data.data : []));
            else setClients([]);
        } catch (err) {
            console.warn(err);
            setClients([]);
        }
        setAff(!aff);
    }


    async function create()
    {
        if (props.user.id_budget && props.user.id_budget !== null) {
            let numero = 0
            if (operations.length !== 0) {
                operations.forEach(projet => {
                    numero = projet[2]
                });
            }
            numero++;
            const params = {
                'create': true,
                'id_budget': props.user.id_budget,
                'user_id': props.user.id
            }
            await axios.post('https://app-slfinance.fr/api/operations.php', qs.stringify(params))
            .then((result) => {
                if (result.data['status'] === 1) {
                    NotificationManager.success(result.data['message'], '', 700);
                    setTimeout(() => window.location = window.location.origin + '/operation/saisie/'+result.data.id_operation+'?new=true', 900);
                }
                else {
                    NotificationManager.warning(result.data['message'], '', 2000);
                }
            })
        }
    }

    async function recalculateProspective()
    {
        try {
            const params = {
                action: 'recalculate_prospective',
                id_budget: props.user.id_budget,
                prosp_an_deb: props.user.config_budget.prosp_an_deb,
                prosp_an_fin: props.user.config_budget.prosp_an_fin
            };
            
            await axios.post('/api/incidences_financieres_operations.php', qs.stringify(params))
            .then((response) => {
                if (!response.data || response.data.status !== 1) {
                    throw new Error(response.data?.message || 'Erreur lors du recalcul des prospectives');
                }
                else {
                    NotificationManager.success('Opération mise à jour', '', 2000);
                    // setLoading(false);
                }
            })
            .catch((error) => {
                console.warn('Erreur lors du recalcul des prospectives:', error);
                throw error;
            });
        } catch (err) {
            console.warn('Erreur lors du recalcul des prospectives:', err);
        }
    }

    async function suppressProjet(id)
    {
        try {
            setIsRecalculating(true);
            const res = await axios.post('/api/operations.php', qs.stringify({ delete: true, id: id }));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success('Opération supprimée', '', 1500);
                await recalculateProspective();
                await mount();
            } else {
                NotificationManager.error('Erreur suppression', '', 2000);
            }
        } catch (err) {
            console.warn(err);
            NotificationManager.error('Erreur serveur', '', 2000);
        } finally {
            setIsRecalculating(false);
        }
    }

    async function toggleCheckbox(id, field, currentValue)
    {
        try {
            setIsRecalculating(true);
            const newValue = currentValue === "1" || currentValue === 1 ? 0 : 1;
            const params = {
                update: true,
                id: id,
                [field]: newValue
            };
            const res = await axios.post('/api/operations.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                await recalculateProspective();
                await mount();
            } else {
                NotificationManager.error('Erreur mise à jour', '', 2000);
            }
        } catch (err) {
            console.warn(err);
            NotificationManager.error('Erreur serveur', '', 2000);
        } finally {
            setIsRecalculating(false);
        }
    }

    useEffect(() => {
        if (props.user === null) {
            props.getUser();
        } else {
            mount();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.user]);

    // tri avec ordre croissant/décroissant
    const sortBy = (field) => {
        let newOrder = 'asc';
        if (sortField === field && sortOrder === 'asc') {
            newOrder = 'desc';
        }
        setSortField(field);
        setSortOrder(newOrder);
        
        setOperations(prev => {
            const copy = Array.isArray(prev) ? [...prev] : [];
            copy.sort((a, b) => {
                const va = a && a[field] !== undefined && a[field] !== null ? a[field] : '';
                const vb = b && b[field] !== undefined && b[field] !== null ? b[field] : '';
                
                let comparison = 0;
                // si nombres
                if (field === 'montant' || field === 'id' || field === 'id_modalite_portage') {
                    comparison = parseFloat(va || 0) - parseFloat(vb || 0);
                } else {
                    comparison = ('' + va).toString().localeCompare(('' + vb).toString());
                }
                
                return newOrder === 'asc' ? comparison : -comparison;
            });
            return copy;
        });
        setAff(!aff);
    };

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    const filtered = operations.filter(op => {
        // Filtre modalité
        if (modaliteFilter && modaliteFilter !== '') {
            if (String(op.id_modalite_portage) !== String(modaliteFilter)) return false;
        }
        // Filtre axe d'intervention
        if (axeFilter && axeFilter !== '') {
            if (String(op.id_axes_interventions) !== String(axeFilter)) return false;
        }
        // Filtre territoire
        if (territoireFilter && territoireFilter !== '') {
            if (String(op.id_territoires) !== String(territoireFilter)) return false;
        }
        // Filtre client
        if (clientFilter && clientFilter !== '') {
            if (String(op.id_clients_epfl) !== String(clientFilter)) return false;
        }
        // Filtre recherche nom (insensible aux accents)
        if (searchText && searchText.trim() !== '') {
            const search = removeAccents(searchText.toLowerCase());
            const nom = removeAccents((op.nom || '').toLowerCase());
            if (!nom.includes(search)) return false;
        }
        // Filtre recherche numéro
        if (searchNumero && searchNumero.trim() !== '') {
            const numero = (op.numero_inventaire || '').toLowerCase();
            if (!numero.includes(searchNumero.toLowerCase())) return false;
        }
        return true;
    });

    return (
        <div>
            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
            <Access needConnection={true} type_user={[0]}>
                <Navbar user={props.user} />

                <Dialog
                    setModalVisible={setDialogModalVisible}
                    modalVisible={dialogModalVisible}
                    callbackDialog={callbackDialog}
                    message={"Confirmez la suppression :"}
                />

                <div style={{display: 'flex'}}>
                    <div style={{flex: 1, margin: 20, display: 'flex'}}>
                        <div style={{flex: 1, display: 'flex'}}>
                            <p>Gestion</p>
                            <p style={{marginLeft: 5}}>\</p>
                            <p style={{marginLeft: 5, color: purple, fontWeight: 'bold'}}>Opérations</p>
                        </div>

                        <div style={{flex: 1}}>
                            {props.user?
                            <p style={{flex: 1, textAlign: 'center'}}>{props.user.nom_budget}</p>
                            :null}
                        </div>

                        <div style={{flex: 1}}>
                        {isRecalculating && (
                            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
                                    <div style={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: '50%',
                                        border: '3px solid #ddd',
                                        borderTop: '3px solid ' + purple,
                                        animation: 'spin 1s linear infinite'
                                    }}></div>
                                    <p style={{margin: 0, color: purple, fontWeight: 600}}>Recalcul des restitutions...</p>
                                </div>
                            </div>
                        )}
                        </div>
                    </div>
                </div>

                <div style={{flex: 1, margin: 20, display: 'flex'}}>
                    <div style={{flex: 1}}></div>
                    <button
                        className='shadow-md p-2 rounded-md'
                        style={ongletListeOperations?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                        onClick={() => {
                            setOngletListeOperations(true);
                            setOngletSyntheseGantt(false);
                            setOngletIncidencesFinancieres(false);
                        }}
                    >
                        Liste des opérations
                    </button>

                    <button
                        className='shadow-md p-2 rounded-md'
                        style={ongletIncidencesFinancieres?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                        onClick={() => {
                            setOngletListeOperations(false);
                            setOngletSyntheseGantt(false);
                            setOngletIncidencesFinancieres(true);
                        }}
                    >
                        Incidences Financières
                    </button>

                    <button
                        className='shadow-md p-2 rounded-md'
                        style={ongletSyntheseGantt?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                        onClick={() => {
                            setOngletListeOperations(false);
                            setOngletSyntheseGantt(true);
                            setOngletIncidencesFinancieres(false);
                        }}
                    >
                        Synthèse des opérations (GANTT)
                    </button>
                    <div style={{flex: 1}}></div>
                </div>

                {ongletListeOperations?
                <div style={{display: 'flex'}}>
                    <div style={{flex: 1}}></div>
                    <button
                        className='shadow-md rounded-md'
                        style={{backgroundColor: green, color: 'white', fontSize: 14, margin: 10, paddingLeft: 10, paddingRight: 10}}
                        onClick={() => {
                            create()
                        }}
                    >
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <Add width="12" />
                            <p style={{marginLeft: 5}}>Créer une opération</p>
                        </div>
                    </button>
                    <div style={{flex: 1}}></div>
                </div>
                :null}

                {ongletListeOperations?
                <>
                <div style={{margin: '0 25px 25px 25px', padding: 20, backgroundColor: '#f8f9fa', borderRadius: 8, border: '1px solid #e0e0e0'}}>
                    <div style={{display: 'flex', alignItems: 'center', marginBottom: 15}}>
                        <p style={{fontSize: 16, fontWeight: 600, color: '#333', margin: 0}}>Filtres</p>
                        <div style={{flex: 1}}></div>
                        <button
                            className='shadow-sm'
                            style={{
                                padding: '8px 16px',
                                borderRadius: 4,
                                border: '1px solid #ccc',
                                backgroundColor: 'white',
                                fontSize: 13,
                                cursor: 'pointer',
                                color: '#666',
                                transition: 'all 0.2s'
                            }}
                            onClick={() => {
                                setSearchNumero('');
                                setSearchText('');
                                setClientFilter('');
                                setAxeFilter('');
                                setTerritoireFilter('');
                                setModaliteFilter('');
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f0f0f0';
                                e.currentTarget.style.borderColor = '#999';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'white';
                                e.currentTarget.style.borderColor = '#ccc';
                            }}
                        >
                            Réinitialiser les filtres
                        </button>
                    </div>
                    
                    <div style={{display: 'flex', gap: 15, marginBottom: 15}}>
                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Rechercher par numéro</p>
                            <input
                                type="text"
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14}}
                                placeholder="Numéro d'inventaire..."
                                value={searchNumero}
                                onChange={e => setSearchNumero(e.target.value)}
                            />
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Rechercher par nom</p>
                            <input
                                type="text"
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14}}
                                placeholder="Nom de l'opération..."
                                value={searchText}
                                onChange={e => setSearchText(e.target.value)}
                            />
                        </div>
                    </div>

                    <div style={{display: 'flex', gap: 15}}>
                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Collectivités</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={clientFilter}
                                onChange={e => setClientFilter(e.target.value)}
                            >
                                <option value=''>Liste des collectivités</option>
                                {clients.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nom}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Axe d'intervention</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={axeFilter}
                                onChange={e => setAxeFilter(e.target.value)}
                            >
                                <option value=''>Tous les axes</option>
                                {axes.map((a) => (
                                    <option key={a.id} value={a.id}>{a.intitule}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Territoires</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={territoireFilter}
                                onChange={e => setTerritoireFilter(e.target.value)}
                            >
                                <option value=''>Tous les territoires</option>
                                {territoires.map((t) => (
                                    <option key={t.id} value={t.id}>{t.intitule}</option>
                                ))}
                            </select>
                        </div>

                        <div style={{flex: 1}}>
                            <p style={{fontSize: 13, paddingLeft: 10, marginBottom: 5, color: '#666'}}>Modalité de portage</p>
                            <select
                                className='shadow-sm'
                                style={{width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: 14, cursor: 'pointer'}}
                                value={modaliteFilter}
                                onChange={e => setModaliteFilter(e.target.value)}
                            >
                                <option value=''>Toutes les modalités</option>
                                {modalites.map((m) => (
                                    <option key={m.id} value={m.id}>{m.intitule}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div style={{margin: 25}}>
                    {(!filtered || filtered.length === 0) ? (
                        <div style={{color: '#666', textAlign: 'center', marginTop: 25}}>Aucune opération pour ce budget</div>
                    ) : (
                        <>
                            <div style={{display: 'flex', padding: '8px 12px', borderBottom: '1px solid #ddd', alignItems: 'center', fontWeight: 600, color: '#333'}}>
                                <div style={{width:30, textAlign:'center'}}></div>
                                <div style={{width:50, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('color')}>
                                    État {sortField === 'color' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:1.5, minWidth:120, cursor:'pointer', display:'flex', alignItems:'center'}} onClick={() => sortBy('numero_inventaire')}>
                                    Numéro {sortField === 'numero_inventaire' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2.5, minWidth:0, cursor:'pointer', display:'flex', alignItems:'center'}} onClick={() => sortBy('nom')}>
                                    Intitulé {sortField === 'nom' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('nom_client')}>
                                    Collectivités {sortField === 'nom_client' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('nom_axe')}>
                                    Axe d'intervention {sortField === 'nom_axe' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('nom_territoire')}>
                                    Territoires {sortField === 'nom_territoire' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{flex:2, textAlign:'center', cursor:'pointer'}} onClick={() => sortBy('nom_modalite')}>
                                    Modalités de portage {sortField === 'nom_modalite' && (sortOrder === 'asc' ? '▲' : '▼')}
                                </div>
                                <div style={{width: 90}}>
                                    <div>Hypothèses</div>
                                    <div style={{display:'flex', justifyContent:'space-between', fontSize:12, fontWeight:600}}>
                                        <div style={{width:30, textAlign:'center'}}>H1</div>
                                        <div style={{width:30, textAlign:'center'}}>H2</div>
                                        <div style={{width:30, textAlign:'center'}}>H3</div>
                                    </div>
                                </div>
                            </div>

                            <div style={{display:'flex', flexDirection:'column', gap:8, marginTop:8}}>
                                {filtered.map((op) => (
                                    <div 
                                        key={op.id} 
                                        style={{display: 'flex', width: '100%', padding: '12px', borderRadius: 6, border: '1px solid #eee', background: 'white', alignItems: 'center', cursor: 'pointer', transition: 'background 0.2s'}}
                                        onClick={() => history.push('/operation/saisie/' + op.id + '?timestamp=' + new Date().getTime())}
                                        onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
                                        onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                                    >
                                        <div style={{width:30, textAlign:'center'}}>
                                            <button onClick={async (e) => {
                                                e.stopPropagation();
                                                await setIdSelected(op.id);
                                                setDialogModalVisible(true);
                                            }} style={{border:'none', background:'transparent', cursor:'pointer', padding: '8px 12px'}}>
                                                <Trash width="18" />
                                            </button>
                                        </div>
                                        <div style={{width:50, textAlign:'center'}}>
                                            <div style={{
                                                width: 16,
                                                height: 16,
                                                borderRadius: '50%',
                                                backgroundColor: (op.color && op.color !== '') ? op.color : '',
                                                margin: '0 auto'
                                            }}></div>
                                        </div>
                                        <div style={{flex:1.5, minWidth:120, fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{op.numero_inventaire || ''}</div>
                                        <div style={{flex:2.5, minWidth:0, fontSize: 14, fontWeight: 'bold'}}>{op.nom || ''}</div>
                                        <div style={{flex:2, textAlign:'center', fontSize: 12}}>{op.nom_client || ''}</div>
                                        <div style={{flex:2, textAlign:'center', fontSize: 12}}>{op.nom_axe || ''}</div>
                                        <div style={{flex:2, textAlign:'center', fontSize: 12}}>{op.nom_territoire || ''}</div>
                                        <div style={{flex:2, textAlign:'center', fontSize: 12}}>{op.nom_modalite || ''}</div>
                                        <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                            <input 
                                                type="checkbox" 
                                                checked={op.h1 === "1" || op.h1 === 1} 
                                                onChange={() => toggleCheckbox(op.id, 'h1', op.h1)}
                                                style={{cursor: 'pointer'}}
                                            />
                                        </div>
                                        <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                            <input 
                                                type="checkbox" 
                                                checked={op.h2 === "1" || op.h2 === 1} 
                                                onChange={() => toggleCheckbox(op.id, 'h2', op.h2)}
                                                style={{cursor: 'pointer'}}
                                            />
                                        </div>
                                        <div style={{width:30, textAlign:'center'}} onClick={(e) => e.stopPropagation()}>
                                            <input 
                                                type="checkbox" 
                                                checked={op.h3 === "1" || op.h3 === 1} 
                                                onChange={() => toggleCheckbox(op.id, 'h3', op.h3)}
                                                style={{cursor: 'pointer'}}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
                </>
                :null}

                {ongletSyntheseGantt?
                <div style={{flex: 1, textAlign: 'center', marginTop: 10, marginLeft: 30, marginRight: 30, marginBottom: 30}}>
                    <GanttSyntheseOperations user={props.user} listeOperations={operations} />
                </div>
                :null}

                {ongletIncidencesFinancieres?
                <IncidendesFinancieresGlobalOperations 
                    anneeDebut={anneeDebut}
                    setAnneeDebut={setAnneeDebut}
                    anneeFin={anneeFin}
                    setAnneeFin={setAnneeFin}
                    user={props.user}
                    onValider={() => {
                        console.log('Valider clicked', { anneeDebut, anneeFin });
                    }}
                />
                :null}

            </Access>
        </div>
    );
}

export default Operations;
